import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_TYPOGRAPHY_BODY } from '../../../../styles/typography/typography';
export var tableCellTheme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          padding: 0,
          height: 48,
          div: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            // the ff is to prevent Safari from adding its own tooltip
            //  on top of our tooltip, which it just does otherwise.
            '&::after': {
              content: '""',
              display: 'block'
            },
            '*:not([class*=icon])': {
              textOverflow: 'inherit',
              overflow: 'inherit'
            },
            '.EmbersProgressBar': {
              paddingLeft: 0
            }
          },
          border: 'none'
        }, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
          '&.MuiTableCell-paddingCheckbox': {
            textAlign: 'center'
          },
          '&.EmbersTable-BodyCell-icon>div': {
            paddingLeft: 8
          },
          '&.EmbersTable-BodyCell-content>div': {
            paddingLeft: 16
          }
        })
      }
    }
  }
});